$(document).ready(function(){

	// -- Enable dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		e.preventDefault();

		if (!$(this).parent('.dropdown').hasClass('open')) {
			closeDropdown();
			$(this).attr('aria-expanded', true).parent('.dropdown').toggleClass('open');
		} else {
			closeDropdown();
		}

	});

	// -- Close dropdown when click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.dropdown-toggle');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			closeDropdown();
	  }
	});


	function closeDropdown(){
		$('.dropdown').removeClass('open');
  	$('.dropdown-toggle').attr('aria-expanded', false);		
	}

});